import { ContactPerson } from '../ContactPerson'
import Location from '../Location'
import { OrganizationUnit } from '../OrganizationUnit'
import { Element } from './Element'

export enum ProfessionalGroup {
  WHITE_COLLAR = 'WHITE_COLLAR',
  BLUE_COLLAR = 'BLUE_COLLAR',
}

export enum SurveyType {
  TEAM = 'TEAM',
  MANAGER = 'MANAGER',
  LEADER = 'LEADER',
}

export type AnswerCountByOrganizationUnit = {
  organizationUnitUUID: string
  answerCount: number
}

export type Floor = {
  uuid: string
  name: string
  squareMeter: number
}

export type SurveyContext = {
  projectUUID: string

  uuid?: string

  departmentName?: string
  professionalGroup?: ProfessionalGroup
  employeeAmount?: number
  organizationUnitList?: OrganizationUnit[]
  contactPersonList?: ContactPerson[]
  location?: Location
  description?: string
  surveyThankYouHeadline?: string
  surveyThankYouText?: string
  surveyTimeLimitReachedHeadline?: string
  surveyTimeLimitReachedText?: string
  deadline?: Date
  amountOfDays?: number
  floors?: Floor[]

  // dynamic properties
  answerCountByManager?: number
  answerCountByLeader?: number
  answerCountByOrganizationUnit?: AnswerCountByOrganizationUnit[]
  totalAnswerCount?: number
  surveyList?: {
    surveyType: SurveyType
    uuid: string
  }[]
}

export type Survey = {
  uuid: string

  surveyContextUUID: string
  surveyType: SurveyType
  elements: Element[]

  // dynamic properties
  totalAnswerCount?: number
  answerCountByUserIdentifier?: number
  context?: SurveyContext
}
